<form class="form-container" [formGroup]="bookingForm" (ngSubmit)="onSubmit()">
  <p class="text intro">{{ 'BOOKINGS_FORM_INFO' | translate }}</p>

  <mat-form-field>
    <mat-label>{{ 'Calendarname' | translate }}</mat-label>
    <input matInput id="name" type="text" formControlName="name" />
    <mat-error>
      {{ nameErrorMessage | translate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Email Address' | translate }}</mat-label>
    <input matInput id="address" type="text" formControlName="address" />
  </mat-form-field>

  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Primary Owner' | translate }}</mat-label>
      <input
        matInput
        id="primaryOwner"
        type="text"
        formControlName="primaryOwner"
      />
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'BOOKINGS_PRIMARY_OWNER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Secondary Owner' | translate }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="'Search for a secondary owner' | translate"
        formControlName="secondaryOwner"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayUserFn"
        (optionSelected)="onSecondaryOwnerSelected($event)"
      >
        @for (person of filteredPeople | async; track person.id) {
          <mat-option [value]="person">
            {{ person.displayName }} ({{ person.userPrincipalName }})
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>
        {{ secondaryOwnerErrorMessage | translate }}
      </mat-error>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'BOOKINGS_SECONDARY_OWNER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>

  <mat-form-field>
    <mat-label>{{ 'Department' | translate }}</mat-label>
    <mat-select id="department" formControlName="department">
      @for (department of departments; track department.id) {
        <mat-option [value]="department.shortName">{{
          department.name | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="address">
    <mat-form-field class="postal-code">
      <mat-label>{{ 'Postal Code' | translate }}</mat-label>
      <input matInput id="postalCode" type="text" formControlName="postalCode" />
    </mat-form-field>
    <mat-form-field class="city">
      <mat-label>{{ 'City' | translate }}</mat-label>
      <input matInput id="city" type="text" formControlName="city" />
    </mat-form-field>
  </div>

  <div class="text section-title">
    {{ 'Services' | translate }}
    <span class="section-hint">{{
      'BOOKINGS_SERVICES_INFO' | translate: { max: maxServices }
    }}</span>
  </div>
  <div formArrayName="services">
    @for (service of services.controls; track service; let i = $index) {
      <div class="service" [formGroupName]="i">
        <mat-form-field class="service-name">
          <mat-label>{{ 'Service name' | translate }}</mat-label>
          <input matInput type="text" formControlName="name" />
          <mat-error>{{ 'Service name is required' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field class="service-duration">
          <mat-label>{{ 'Duration (minutes)' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="5"
            max="1440"
            step="5"
            formControlName="durationMinutes"
          />
          <mat-error>{{
            'BOOKINGS_RANGE_ERROR' | translate: { min: 5, max: 1440 }
          }}</mat-error>
        </mat-form-field>
        <!-- Removing the row detaches the button before the modal's outside-click check; the class exempts it -->
        <button
          mat-button
          type="button"
          class="remove-service form-footer-nav-button"
          (click)="removeService(i)"
        >
          {{ 'Remove' | translate }}
        </button>
      </div>
    }
  </div>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="services.length >= maxServices"
    (click)="addService()"
  >
    {{ 'Add service' | translate }}
  </button>

  <mat-expansion-panel class="advanced">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Advanced' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div formGroupName="schedulingPolicy" class="advanced-content">
      <mat-form-field>
        <mat-label>{{ 'Time slot interval (minutes)' | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="5"
          max="1440"
          formControlName="timeSlotIntervalMinutes"
        />
        <mat-error>{{
          'BOOKINGS_RANGE_ERROR' | translate: { min: 5, max: 1440 }
        }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Minimum lead time (hours)' | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="8760"
          formControlName="minimumLeadTimeHours"
        />
        <mat-error>{{
          'BOOKINGS_RANGE_ERROR' | translate: { min: 0, max: 8760 }
        }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Maximum days in advance' | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="1"
          max="365"
          formControlName="maximumAdvanceDays"
        />
        <mat-error>{{
          'BOOKINGS_RANGE_ERROR' | translate: { min: 1, max: 365 }
        }}</mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="allowStaffSelection">
        {{ 'Customers can choose a staff member' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="sendConfirmationsToOwner">
        {{ 'Send booking confirmations to the owner' | translate }}
      </mat-checkbox>
    </div>
  </mat-expansion-panel>

  <div class="publish">
    <mat-checkbox formControlName="publish">
      {{ 'Publish directly' | translate }}
    </mat-checkbox>
    <div class="text section-hint">
      {{ 'BOOKINGS_PUBLISH_INFO' | translate }}
    </div>
  </div>

  <hr />
  <div class="form-footer">
    <div class="form-nav"></div>
    <div class="submit">
      <button mat-flat-button color="primary" [disabled]="!bookingForm.valid">
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</form>
